import * as Immutable from 'immutable';

import { Path } from './path';
import { Handler, Result, ok } from './handler';
import { SchemaError } from './schema-error';

export class SchemaEngine {

  private schema: Handler;

  constructor(schema: Handler) {
    this.schema = schema;
  }

  public getValue(element: string, data: any) {
    const path = Path.parse(element);
    const immutable = Immutable.fromJS(data);
    const result = this.schema.get(path, immutable);

    return result;
  }

  public setValue(element: string, value: string, data: any): Result<any, SchemaError> {
    const path = Path.parse(element);
    const immutable = Immutable.fromJS(data);

    const result = this.schema.set(path, immutable, value);
    if (!result.success) {
      return result;
    }

    return ok(result.value.toJS());
  }
}


